"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let globalFeatureId = 1;
const existing = new Map();
const getFeatureId = (requested) => {
    if (requested || requested === 0) {
        if (!existing.has(requested)) {
            existing.set(requested, requested);
        }
        return requested;
    }
    else {
        let nextId;
        do {
            nextId = ++globalFeatureId;
        } while (existing.has(nextId));
        existing.set(nextId, nextId);
        return nextId;
    }
};
const resetFeatureIds = (features) => {
    const temp = features.type === "Feature" ? [features] : features.features;
    temp.forEach((feature) => {
        if (feature.id || feature.id === 0) {
            existing.delete(feature.id);
        }
    });
};
const updateFeatureIds = (features) => {
    const temp = features.type === "Feature" ? [features] : features.features;
    temp.forEach((feature) => {
        feature.id = getFeatureId(feature.id);
    });
};
exports.default = { getFeatureId, resetFeatureIds, updateFeatureIds };
